'use client';

import React from 'react';
import { Collapsible as CollapsiblePrimitive } from 'radix-ui';
import { cn } from '@/lib/utils';

function Collapsible({ ...props }) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

function CollapsibleTrigger({ ...props }) {
  return (
    <CollapsiblePrimitive.CollapsibleTrigger
      data-slot="collapsible-trigger"
      {...props}
    />
  );
}

function CollapsibleContent({ className, children, ...props }) {
  const [isAnimating, setIsAnimating] = React.useState(false);

  const handleAnimationStart = () => setIsAnimating(true);
  const handleAnimationEnd = () => setIsAnimating(false);

  return (
    <CollapsiblePrimitive.CollapsibleContent
      data-slot="collapsible-content"
      className={cn(
        // Only hide overflow during animation, allow visibility after
        isAnimating ? 'overflow-hidden' : 'overflow-visible',
        'data-[state=closed]:animate-collapsible-up data-[state=open]:animate-collapsible-down',
        className,
      )}
      style={{
        '--radix-collapsible-content-height': 'var(--radix-collapsible-content-height)',
      }}
      onAnimationStart={handleAnimationStart}
      onAnimationEnd={handleAnimationEnd}
      {...props}
    >
      <div className="collapsible-content-wrapper">
        {children}
      </div>
    </CollapsiblePrimitive.CollapsibleContent>
  );
}

export { Collapsible, CollapsibleContent, CollapsibleTrigger };
